import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { updateSocket } from '../../../utils/socket';
import { SOCKET_EVENTS } from '../../../constants/defaultValues';

const SocketUpdater = () => {
    const socketContext = useSelector(state => state.socket.context);

    useEffect(() => {
        updateSocket(SOCKET_EVENTS.contextUpdated, socketContext);
    }, [socketContext]);

    return null;
};

export default SocketUpdater;
